import { Link } from "react-router-dom";
import "../styles/header.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe, faHouse} from "@fortawesome/free-solid-svg-icons";
import { useLang } from "../context/LangContext";
import { useEffect, useState, useRef } from "react";
import { fetchPageContent } from "../api/contentApi";


export default function Header() {
  const { lang, setLang} = useLang();
  const [showLanguages, setShowLanguages] = useState(false);
  const [content, setContent] = useState ({
    about_title: "",
    career_title: "",
    collab_title: "",
    services_title: "",
  });

  const dropdownRef = useRef(null);
  const handleLanguageChange = (selectedLang) => {
  setLang(selectedLang);
  setShowLanguages(false);
};

    useEffect(() => {
    async function loadTitles() {
      try {
        // Fetch each tab separately
        const aboutData = await fetchPageContent("about", lang);
        const careerData = await fetchPageContent("career", lang);
        const collaborationData = await fetchPageContent("collaboration", lang);
        const mainData = await fetchPageContent("main", lang);
        const servicesData = await fetchPageContent("services", lang);

        setContent({
          about_title: aboutData.about_title || "",
          services_title: servicesData.services_title || "",
          career_title: careerData.career_title || "",
          collab_title: collaborationData.collab_title || "",
          company_name: mainData.company_name || "",
          
        });
      } catch (err) {
        console.error("Error fetching header titles:", err);
      }
    }

    loadTitles();
  }, [lang]);

  useEffect(() => {
  function handleClickOutside(event) {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target)
    ) {
      setShowLanguages(false);
    }
  }

  document.addEventListener("mousedown", handleClickOutside);
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);

    const scrollToFooter = () => {
    const footer = document.getElementById("footer");
    if (footer) {
      footer.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <header className="header">
      <div className="header-left">
        <a href="/" className="logo-link">
          <img src="/logo.png" alt="Logo" className="logo" />
        </a>
        {content.company_name && (
        <Link to="/" className="company-name">
        <span >{content.company_name}</span>
        </Link>
        )}
      </div>
      
      <div className="header-center">
          <nav className="header-services">
        <Link to="/"><FontAwesomeIcon icon={faHouse} className="header-icon"/></Link>
        <Link to="/about">{content.about_title}</Link>
        <Link to="/services">{content.services_title}</Link>
        <Link to="/collaboration">{content.collab_title}</Link>
        <Link to="/career">{content.career_title}</Link>
      </nav>
      </div>

      <div className="header-right">

        {/* Language switcher with dropdown: */}
        
    <div className="language-switcher" ref={dropdownRef}>
  <button
  className="globe-btn"
  onClick={() => setShowLanguages(!showLanguages)}
>
  <FontAwesomeIcon icon={faGlobe} />
  <span>{lang.toUpperCase()}</span>
</button>

  {showLanguages && (
    <div className="language-dropdown">
      <button onClick={() => handleLanguageChange("fi")}>🇫🇮 FI</button>
      <button onClick={() => handleLanguageChange("ua")}>🇺🇦 UA</button>
      <button onClick={() => handleLanguageChange("ru")}>🇷🇺 RU</button>
      <button onClick={() => handleLanguageChange("eng")}>🇬🇧 ENG</button>
    </div>
  )}
</div>
        <button className="contact-btn" onClick={scrollToFooter}>Contact Us</button>
      </div>
    </header>
  );
}